import React, { useState } from "react";
import SourceIQLogo from "../UILibrary/SourceIQLogo";
import { useNavigate } from "react-router-dom";

const PreRegistration = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleDone = () => {
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const { firstName, lastName, email } = formData;

    const requestBody = {
      firstName,
      lastName,
      email,
    };

    try {
      const response = await fetch("https://registration-api-hhcvfmdce5gphfdf.eastus-01.azurewebsites.net/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Something went wrong with the submission");
      }

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="w-full min-h-screen bg-[#fdffeb] flex justify-center py-10">
        <div className="absolute top-30 left-1/2 transform -translate-x-1/2 mb-5">
          <SourceIQLogo fill="#1E1E1E" width={150} height={30} />
        </div>

        {!isSubmitted ? (
          <div className="w-full max-w-[814px] mt-20 bg-white rounded-[18px] shadow-[0px_4px_54px_0px_rgba(0,0,0,0.15)] border border-neutral-300 overflow-hidden px-5 py-10 relative">
            <div className="flex justify-center items-center gap-1.5 flex-col mb-10">
              <div className="text-center text-[#1e1e1e] text-2xl sm:text-3xl md:text-4xl font-semibold font-['Hanken Grotesk']">
                SourceIQ is coming soon!
              </div>
              <div className="w-full max-w-[538px] text-center text-[#535353] text-base sm:text-lg md:text-xl font-normal font-['Hanken Grotesk'] leading-relaxed">
                We're hard at work building SourceIQ (formerly TalkDEI), the
                intelligent solution revolutionizing your procurement process.
                Join Our Intelligent Community and Get Early Access to Smart
                Sourcing.
              </div>
            </div>

            <form
              className="flex flex-col gap-7 justify-center"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col gap-[7px] px-6 sm:px-12 md:px-24">
                <label className="text-base font-normal text-left text-[#1d2639] font-['Hanken Grotesk']">
                  First Name
                </label>
                <input
                  className="w-full h-12 pl-4 bg-neutral-100 border-2 rounded-lg"
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter your first name"
                />
              </div>

              <div className="flex flex-col gap-[7px] px-6 sm:px-12 md:px-24">
                <label className="text-base font-normal text-left text-[#1d2639] font-['Hanken Grotesk']">
                  Last Name
                </label>
                <input
                  className="w-full h-12 pl-4 bg-neutral-100 border-2 rounded-lg max-w-[582px]"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter your last name"
                />
              </div>

              <div className="flex flex-col justify-center gap-[7px] px-6 sm:px-12 md:px-24">
                <label className="text-base font-normal text-left text-[#1d2639] font-['Hanken Grotesk']">
                  Email
                </label>
                <input
                  className="w-full h-12 pl-4 bg-neutral-100 border-2 rounded-lg max-w-[582px]"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
              </div>

              <div className="flex justify-center mt-10">
                <button
                  type="submit"
                   className="w-[155px] py-3 px-6 bg-[#eaf524] rounded-[20px] text-center text-[#1e1e1e] text-2xl font-medium"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="w-full max-w-[814px] mt-20 bg-white rounded-[18px] shadow-[0px_4px_54px_0px_rgba(0,0,0,0.15)] border border-neutral-300 overflow-hidden px-5 py-10 flex justify-center items-center flex-col ">
            <svg
            className="w-[232px] h-[170px] sm:w-[259px] sm:h-[211px] md:w-[270px] md:h-[280px] lg:w-[350px] lg:h-[280px] "
              viewBox="0 0 380 389"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M262.545 69.8757C219.916 6.24415 157.726 9.96883 123.903 78.1704C90.0793 146.372 97.207 253.607 139.822 317.196C182.436 380.784 244.597 377.081 278.435 308.887C312.273 240.692 305.116 133.479 262.545 69.8757Z"
                fill="#CBE3F6"
              />
              <path
                d="M139.822 317.196C97.2212 253.578 90.0721 146.351 123.917 78.1417C157.762 9.93294 219.916 6.24427 262.545 69.8758C305.174 133.507 312.28 240.714 278.45 308.93C244.619 377.146 182.437 380.856 139.836 317.239M263.118 68.7125C220.091 4.47437 157.363 8.16622 123.201 77.093C89.038 146.02 96.2577 254.192 139.263 318.402C182.269 382.611 245.024 378.862 279.18 310.021C313.337 241.181 306.102 132.929 263.118 68.7125Z"
                fill="#0088FF"
              />
              <path
                d="M240.142 71.7686C218.881 39.8809 192.712 24.8503 167.617 26.3571C142.522 27.864 118.586 45.8076 101.607 80.0269C84.6283 114.246 77.9591 158.005 80.8613 201.267C83.7635 244.529 96.1864 287.215 117.526 319.088C138.867 350.961 165.042 365.941 190.13 364.449C215.218 362.956 239.196 344.927 256.14 310.779C273.083 276.632 279.774 232.794 276.9 189.546C274.027 146.299 261.546 103.584 240.142 71.7686Z"
                fill="#EBF6FF"
              />
              <path
                d="M240.75 70.5334C197.723 6.25949 135.089 9.97946 100.833 78.9139C66.5773 147.848 73.861 255.927 116.939 320.244C160.017 384.561 222.658 380.826 256.856 311.864L256.494 311.328L256.125 310.772C239.182 344.919 215.196 362.928 190.116 364.442C165.035 365.956 138.845 350.932 117.512 319.081C96.1792 287.229 83.7275 244.529 80.8468 201.26C77.966 157.991 84.6779 114.181 101.607 80.0268C118.537 45.8722 142.536 27.871 167.617 26.3571C192.697 24.8432 218.881 39.8809 240.142 71.7686C261.403 103.656 273.926 146.321 276.807 189.59C279.688 232.859 272.99 276.675 256.047 310.822L256.416 311.379L256.778 311.914C290.983 242.973 283.793 134.922 240.729 70.6123"
                fill="#0088FF"
              />
              <path
                d="M139.914 133.996L170.155 205.126L214.646 119.186L230.51 146.74L165.129 264.496L125.273 158.874L139.914 133.996Z"
                fill="#EBF6FF"
                stroke="#0088FF"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M230.51 146.74L195.634 209.548L170.526 204.399L214.646 119.186L230.51 146.74Z"
                fill="#CBE3F6"
                stroke="#0088FF"
                stroke-miterlimit="10"
              />
              <path
                d="M151.495 161.238L125.544 159.579L125.273 158.873L139.914 133.996L151.495 161.238Z"
                fill="#CBE3F6"
                stroke="#0088FF"
                stroke-miterlimit="10"
              />
            </svg>
            <div className="text-center mt-10 text-[#1e1e1e] text-2xl sm:text-3xl md:text-4xl font-semibold font-['Hanken Grotesk']">
              Your details have been received
            </div>
            <div className="w-full max-w-[312px] text-center text-[#535353] text-base sm:text-lg md:text-xl font-normal font-['Hanken Grotesk'] leading-relaxed">
              We’ll reach out to you for more updates
            </div>
            <div className="mt-10">
              <button
                className="w-[155px] py-3 px-6 bg-[#eaf524] rounded-[20px] text-center text-[#1e1e1e] text-2xl font-medium"
                onClick={handleDone}
              >
                Done
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PreRegistration;
